import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { GoogleTagManagerDomainService } from '@shared/domain/google-tag-manager-domain.service';

export const googleTagManagerInitializerProvider: EnvironmentProviders = provideAppInitializer(() => {
  inject(GoogleTagManagerDomainService);
});
